import React, { Component } from "react";
import * as Yup from "yup";
import { connect } from "react-redux";
import _ from "lodash";

import Form from "../../../../../../utils/forms/components/Form";
import { FormGridField } from "../../../../../../utils/forms/components/FormGrid";
import { hallsStoreSelectors } from "../../../../store/store";
import { HallsActionCreators } from "../../../../actions/actionCreators";
import { ActionCreator } from "../../../../../../actions/actions";
import { HallCreateBaseInfo } from "../../../../../../types/types";
import { OSMAdress } from "../../../../../../types/addressTypes";
import {CreationModes} from "../../../../reducers/creationMode.reducer";
import {HallBaseConfig} from "../../../../reducers/hallsList.reducer";

import "./AddressForm.component.scss";

let addressFormFields: FormGridField[] = [
    {
        name: "address_line_1",

        fieldType: "input",
        fieldOptions: {
            id: "BasicConfigAddr1",
            placeholder: "Address (line 1)",
            inputType: "text",
            label: "Address (line 1)"
        },

        validation: Yup.string()
            .required("Field is required."),

        columnClass: "col-12",
        formSpacing: false
    },

    {
        name: "address_line_2",

        fieldType: "input",
        fieldOptions: {
            id: "BasicConfigAddr2",
            placeholder: "Address (line 2)",
            inputType: "text",
            label: "Address (line 2)"
        },

        validation: Yup.string(),

        columnClass: "col-12",
        formSpacing: false
    }
];

export interface AddressFormProps {
    creatingHall: {
        values: HallCreateBaseInfo;
        isValid: boolean;
    };
    addressSuggestions: OSMAdress[];
    updateCreatingHall: ActionCreator;
    pickedSuggestionCount: number;
    validateForm: any;
    creationMode: any;
    inspectingHall: HallBaseConfig;
}

class AddressForm extends Component<AddressFormProps, {}> {
    onAddressChange = _.debounce(formEvent => {
        const newFormValues = {
            ...(this.props.creatingHall
                ? this.props.creatingHall.values
                : null),
            ...formEvent.values
        };

        this.props.updateCreatingHall(
            newFormValues,
            this.props.validateForm(newFormValues)
        );
    }, 100);

    render() {
        const suggestionsClass =
            "suggestions-container" +
            (this.props.addressSuggestions.length > 0
                ? " suggestions-container-show"
                : " suggestions-container-hide");

        addressFormFields[0].fieldOptions.disabled = addressFormFields[1].fieldOptions.disabled = false;
        addressFormFields[0].validation = Yup.string()
            .required("Field is required.")
            .max(30, "Max. 30 characters.");
        addressFormFields[1].validation = Yup.string()
            .max(30, "Max. 30 characters.");

        if((this.props.creationMode === CreationModes.ADD_HALL &&
            (!this.props.creatingHall.values.subsidiary ||
                !this.props.creatingHall.values.name ||
                this.props.creatingHall.values.hall_code !== 0)) ||
            (this.props.creationMode === CreationModes.EDIT_HALL &&
                !this.props.creatingHall.values.name ||
                (this.props.creatingHall.values.hall_code === undefined && this.props.inspectingHall.hall_code) ||
               (this.props.creatingHall.values.hall_code && this.props.creatingHall.values.hall_code !== 0))){
            addressFormFields[0].fieldOptions.disabled = addressFormFields[1].fieldOptions.disabled = true;
            addressFormFields[0].validation = Yup.string().required("Field is required.");
            addressFormFields[1].validation = Yup.string();

        }
        return (
            <div>
                <Form
                    fields={addressFormFields}
                    key={"addressform" + this.props.pickedSuggestionCount + this.props.creatingHall.values.hall_code}
                    initialValues={
                        this.props.creatingHall
                            ? {
                                  address_line_1:
                                      this.props.creatingHall.values
                                          .address_line_1 || "",
                                  address_line_2:
                                      this.props.creatingHall.values
                                          .address_line_2 || ""
                              }
                            : {
                                  address_line_1: "",
                                  address_line_2: ""
                              }
                    }
                    onChange={this.onAddressChange}
                />
                {/*<div className={suggestionsClass}><SuggestionsBox /></div>*/}
            </div>
        );
    }
}

const mapStateToProps = state => ({
    creatingHall: hallsStoreSelectors.creatingHall(state),
    addressSuggestions: hallsStoreSelectors.addressSuggestions(state),
    pickedSuggestionCount: hallsStoreSelectors.pickedSuggestionCount(state),
    creationMode: hallsStoreSelectors.creationMode(state),
    inspectingHall: hallsStoreSelectors.inspectingHall(state)
});

const mapDispatchToProps = {
    updateCreatingHall: HallsActionCreators.updateCreatingHall
};

export default connect(mapStateToProps, mapDispatchToProps)(AddressForm);
